<template>
  <div class="w-full pb-24" :class="route.name === `index` ? 'pb-24':'py-14 lg:py-28'">
    <div class="container-1 space-y-12">
      <div v-if="route.name === `index`">
        <div class="uppercase md:text-[1.4vw] lg:text-[1.1vw] font-semibold figtree bg-[#AEEDEA] text-[#313187] px-2 py-1 rounded mb-1 inline-block">Our Client</div>
        <div class="text-[32px] leading-[38px] md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[2.6vw] font-semibold figtree text-[#313187]">ImpacThink Portfolio</div>
      </div>
      <div v-else>
        <div class="uppercase md:text-[1.4vw] lg:text-[1.1vw] font-semibold figtree bg-[#AEEDEA] text-[#313187] px-2 py-1 rounded mb-1 inline-block">Our Client</div>
        <div class="text-[32px] leading-[38px] md:text-[2.4vw] md:leading-[2.8vw] lg:text-[2.2vw] lg:leading-[2.6vw] font-semibold figtree text-[#313187]">Proud to Have Served</div>
      </div>
      <div>
        <div class="">
          <div v-for="(item, i) in items" :class="`client-item-${i}`" class="max-w-[30rem] pl-6 relative pb-6 md:pb-12">
            <div v-if="!item.type">
              <div v-if="i !== items.length - 1" class="absolute w-[1px] h-full top-0 left-1 bg-gray-100">
                <div :class="`client-progress`" class="w-[1px] bg-primary transition-all duration-100"></div>
              </div>
              <div :class="[{'active': items.isActive}]" class="circle circle-outer absolute w-[10px] h-[10px] rounded-full -top-[2.6px] -left-[0.4px] bg-white flex items-center justify-center">
                <div class="circle circle-inner w-[4px] h-[4px] rounded-full"></div>
              </div>
              <figure class="aspect-video rounded-lg overflow-hidden max-w-[160px]">
                <img :src="config.public.cdnUrl+config.public.cdnFolder+item.img_src" alt="" class="w-full h-full object-cover">
              </figure>
              <div class="figtree text-[20px] leading-[24px] text-primary font-bold mt-3">{{ item.title[locale] }}</div>
              <div class="figtree text-[16px] leading-[24px] font-semibold mt-3">{{ item.subtitle[locale] }}</div>
              <div class="figtree text-[14px] leading-[24px] mt-3" v-html="item.description[locale]"></div>
              </div>
          </div>
        </div>
        <div class="w-full flex justify-center mt-6 md:mt-12" data-aos="fade-up" data-aos-easing="ease-out-sine" data-aos-duration="700" data-aos-delay="200">
          <NuxtLink
            :to="({name: 'our-services'})"
            class="figtree group rounded-3xl h-full py-2 px-3 lg:py-3 lg:px-6 w-fit hover:bg-ip-color-2 bg-ip-color-3 hover:shadow-lg font-semibold text-base md:text-[1.4vw] lg:text-[1.1vw] hover:text-ip-color-3 text-white flex items-center gap-1 transition-colors duration-300">
              See More
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="w-5 h-5 group-hover:translate-x-1 transition-transform duration-300">
                <path fill-rule="evenodd" d="M4.22 11.78a.75.75 0 0 1 0-1.06L9.44 5.5H5.75a.75.75 0 0 1 0-1.5h5.5a.75.75 0 0 1 .75.75v5.5a.75.75 0 0 1-1.5 0V6.56l-5.22 5.22a.75.75 0 0 1-1.06 0Z" clip-rule="evenodd" />
              </svg>
          </NuxtLink>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const route = useRoute();
 
const locale = ref('id')
 
const config = useRuntimeConfig();
const props = defineProps(['items']);

onMounted(() => {
  if (process.client) {
    nextTick(() => {
      const observers = [];
      const entries = [];
      props.items.forEach((item, index) => {
        if (!item.type) {
          const el = document.querySelector('.client-item-' + index);
          const options = {
            root: null,
            rootMargin: '0px',
            threshold: [0.0, 0.05, 0.1, 0.15, 0.2, 0.25, 0.3, 0.35, 0.4, 0.45, 0.5, 0.55, 0.6, 0.65, 0.7, 0.75, 0.8, 0.85, 0.9, 0.95, 1.0],
          };
          const callback = (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                if (index !== 0) {
                  document.querySelector(`.client-item-${index - 1} .client-progress`).style.height = `${entry.intersectionRatio * 100}%`;
                }
                if (entry.intersectionRatio >= 1.0) {
                  document.querySelector(`.client-item-${index} .circle.circle-outer`).classList.add('active');
                } else {
                  document.querySelector(`.client-item-${index} .circle.circle-outer`).classList.remove('active');
                }
              } else {
                if (document.querySelector(`.client-item-${index - 1} .client-progress`)) document.querySelector(`.client-item-${index - 1} .client-progress`).style.height = `${0}%`;
                document.querySelector(`.client-item-${index} .circle.circle-outer`).classList.remove('active');
              }
            });
          };
          observers[index] = new IntersectionObserver(callback, options);
          observers[index].observe(el);
        }
      });
    });
  }
});
const navbarStore = useNavbarStore();

</script>

<style lang="scss" scoped>
.circle-outer{
  @apply transition-all;
  .circle-inner {
    @apply bg-[#cdcdcd];
  }
  &.active {
    animation: bounce 450ms;
    animation-timing-function: linear;
    @apply border border-[#313187];
    .circle-inner {
      @apply bg-[#313187];
    }
  }
}

@keyframes bounce {
  25% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.4);
  }
  75% {
    transform: scale(1.2);
  }
  100% {
    transform: scale(1.1);
  }
}

</style>
